import { usePreferedDateFormat } from 'src/util/DateFormatter';

export const GetMetaData = (documentDetailsData: any) => {
  const { preferedDateFormat } = usePreferedDateFormat();
  return {
    productInformation: [createData('Product :', 'NCC-1701')],
    referenceModels: [
      createData('Reference Model Versions:', `ISF RM v1.0`),
      createData('Artifacts:', documentDetailsData && documentDetailsData.isf_artifact_name)
    ],
    fileInfo: [
      createData('File Name:', documentDetailsData && documentDetailsData.isf_raw_file_name),
      createData('Size:', `${documentDetailsData && documentDetailsData.isf_doc_size} KB `),
      createData(
        'Format:',
        documentDetailsData && documentDetailsData.docFormat
          ? documentDetailsData.docFormat
          : documentDetailsData.isf_doc_viewer_format || 'PDF'
      ),
      createData('Pages:', documentDetailsData && documentDetailsData.isf_doc_viewer_pages)
    ],
    inspectionReadiness: [createData('Inspection Ready?:', ''), createData('IR Issue Type:', '')]
  };
};

function createData(name: string, value: string | null) {
  return { name, value };
}
